<template>
  <div class="hello">
    <h1>教育圈</h1>
    <img
      src="../assets/logo.png"
      width="100%"
      v-on:click="open_app_click"
      class="img_1"
    />

    <div>
      <img
        src="../assets/h5_open_app.png"
        v-on:click="open_app_click"
        class="img_1"
      />
    </div>
  </div>
</template>

<script>
import http from "../utils/http";
import qs from "qs";

export default {
  name: "EduDownload",
  data() {
    return {};
  },
  methods: {
    open_app_click(event) {
      //这里举个美团的例子   imeituan://就是android和ios需要设置的scheme
      window.location.href = "zjyopenapp://zjy";
      //这样如果你安装了app就可以成功唤醒app了
      //这个延时就是在三秒没有反应跳到百度了，这里你可以写下载链接。或者引导用户下载。
      setTimeout(function() {
        let a = document.createElement("a");
        a.href = "https://cdn.zjyjc.com/apk/教育圈.apk";
        a.click();
      }, 3000);
    },

    testApp(url) {
      var timeout,
        t = 1000,
        hasApp = true;
      setTimeout(function() {
        if (!hasApp) {
          //未安装app
          if (browser.versions.ios) {
            window.location.href = "${url_ios}"; //ios下载地址
          } else {
            window.location.href = "${url_android}"; //安卓下载地址
          }
        }
        document.body.removeChild(ifr);
      }, 2000);
      var t1 = Date.now();
      var ifr = document.createElement("iframe");
      ifr.setAttribute("src", url);
      ifr.setAttribute("style", "display:none");
      document.body.appendChild(ifr);
      timeout = setTimeout(function() {
        var t2 = Date.now();
        if (!t1 || t2 - t1 < t + 100) {
          hasApp = false;
        }
      }, t);
    },

    browser() {
      var u = navigator.userAgent,
        app = navigator.appVersion;
      return {
        trident: u.indexOf("Trident") > -1, //IE内核
        presto: u.indexOf("Presto") > -1, //opera内核
        webKit: u.indexOf("AppleWebKit") > -1, //苹果、谷歌内核
        gecko: u.indexOf("Gecko") > -1 && u.indexOf("KHTML") == -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf("Android") > -1 || u.indexOf("Linux") > -1, //android终端或者uc浏览器
        iPhone: u.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf("iPad") > -1, //是否iPad
        webApp: u.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
        weixin: u.indexOf("MicroMessenger") > -1, //是否微信 （2015-01-22新增）
        qq: u.match(/\sQQ/i) == " qq" //是否QQ
      };
    }
  },
  created() {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: bold;
  size: 46px;
}
.articleTitle {
  font-weight: bold;
  font-size: 40px;
  text-align: left;
  margin-right: 40px;
  margin-left: 40px;
  color: #000;
}
.articleSource {
  margin-top: 20px;
  margin-left: 40px;
  float: left;
}
.span_1 {
  font-size: 28px;
  color: #3e7ad0;
  font-weight: 400;
}
.span_2 {
  margin-left: 40px;
  font-size: 24px;
  color: #999999;
  font-weight: 400;
}
ol {
  float: left;
  margin-left: 20px;
  padding: 10px;
}
li {
  flex: 1;
}
ul {
  list-style-type: none;
  padding: 0;
}

a {
  color: #42b983;
}
p {
  color: #333;
  font-size: 32px;
  text-align: left;
  width: 100%;
  line-height: 150%;
}
.hello {
  width: 100%;
}
img {
  width: 100%;
}
.img_1 {
  width: 300px;
  margin-top: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/EduDownload.vue